<template>
    <div>
    <Head>
        <title>{{ category.category_name }} | Rothco</title>
        <meta name="description" :content="category.meta_desc" />
        <meta name="keywords" :content="category.meta_keywords" />
    </Head>
    <Cms ref="categories" model="categories" driver="builder" is-data v-show="false" v-model="categoryData" :searchParams="searchParams"/>

    <Cms
        model="category-landing-content"
        is-section
        driver="builder"
        v-model="builderData"
        content-prop="content"
        :components="getBuilderComponents({include: [ seoCopyInit, subCategoryLaunchers ]})"
        :injectedData="{ category, ...childCategoriesMap }"
        :search-params="landingPageSearchParams"
    />
    </div>
</template>
<script setup lang="ts">
    import Cms from "@/components/Cms.vue";
    // import { registeredComponents } from "../../category-page-init-builder";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { seoCopyInit } from "@/helpers/builder-init/SeoCopy";
    import { subCategoryLaunchers } from "@/helpers/builder-init/SubCategoryLaunchers";
    import { ref, computed, provide, watch } from "vue";
    import type { PropType } from "vue";
    import { Head } from "@inertiajs/vue3";
    // import { route } from "ziggy-js";
    import { useCategoryLandingStore } from "@/store/categoryLandingStore";

    let props = defineProps({
        category: {
            type: Object as PropType<any>,
            required: true
        }
    });

    let childCategoriesMap = computed(() => {
        return (
            props.category.child_category?.reduce?.(
                (acc: any, category: any) => {
                    acc[slugToPascalCase(category.seo_name)] = category;
                    return acc;
                },
                {}
            ) ?? {}
        );
    });


    let builderData = ref({
        metaDescription: "",
        metaKeywords: ""
    });
    
    function slugToPascalCase(slug: string) {
        if (!slug) return "";
        return slug
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join("");
    }
    let categoryData = ref([]);
    let searchParams = computed(()=>{
        return {
            "data.name.$in": props.category.child_category?.map((cat) => cat.seo_name) ?? []
        }
    })

    let { setChildCategories, setBuilderCategories } = useCategoryLandingStore();

    setChildCategories(props.category.child_category);
    watch(()=>categoryData, (newVal)=>{
        if(newVal.value.length > 0){
            setBuilderCategories(newVal.value);
        }
    }, {deep: true})

    let landingPageSearchParams = computed(()=>{
        return {
            'data.seoName.$eq': props.category.seo_name,
        }
    })
</script>
